"use strict";

const Tabs = () => {
    const init = () => {
        window.refreshTabs = function(){
            var $tabsContainers = $('.js-tabs');
            if ($tabsContainers.length > 0) {
                $tabsContainers.each(function(){
                    var $tabsContainer = $(this);
                    var $tabs = $tabsContainer.find('.js-tabs-tab');
                    if($tabsContainer.data('type') !== undefined) {
                        var $pages = $tabsContainer.find('.js-tabs-page[data-type="'+$tabsContainer.data('type')+'"]');
                    }else{
                        var $pages = $tabsContainer.find('.js-tabs-page');
                    }
                    var $select = $tabsContainer.find('.js-tabs-select');                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
                    
                    $tabs.on('click', function(e){
                        e.preventDefault()
                        var $tab = $(this);
                        $tab.siblings('.js-tabs-tab').removeClass('active');
                        $tab.addClass('active');
                        if($tab.data('id') === 'all'){
                            $pages.addClass('active');
                            $pages.find('.slick-slider').slick('refresh');
                            $pages.filter('[data-bg]').each(function(){
                                $(this).removeClass('bg-grey bg-white');
                                $(this).addClass('bg-'+$(this).data('bg'));
                            });
                        }else{
                            $pages.removeClass('active');
                            var $page = $pages.filter('[data-id="'+$tab.data('id')+'"]');
                            $page.addClass('active');
                            $page.find('.slick-slider').slick('refresh');
                            if($page.data('bg') !== undefined){
                                $page.removeClass('bg-grey bg-white');
                                $page.addClass('bg-grey');
                            }
                        }
                        $select.val($tab.data('id'));
                        $select.niceSelect('update');
                        if($tab.data('slug') !== undefined){
                            window.history.pushState({}, "", window.location.protocol + '//' + window.location.host + $(this).data('slug'));
                        }
                    });
                    
                    if($tabs.filter('.js-tabs-starts-active').length > 0){
                        $tabs.filter('.js-tabs-starts-active').trigger('click');
                    }else{
                        $tabs.filter(':first-child').trigger('click');
                    }
                    
                    $select.on('change', function(){
                        $tabs.filter('[data-id="'+$(this).val()+'"]').trigger('click');
                        $(this).niceSelect('update');
                    });

                    $tabsContainers.find('.js-tabs-side-scroller .js-tabs-tab').on('click', function() {
                        var $this = $(this)
                        var $scroller = $this.parents('.js-tabs-side-scroller')
                        $scroller.animate({
                            scrollLeft: $scroller.scrollLeft() + $this.position().left
                        }, 100);
                    });
                })
            }
        }

        window.clickTab = function($tab){
            var $tabsContainer = $tab.closest('.js-tabs');
            if($tabsContainer.data('type') !== undefined) {
                var $pages = $tabsContainer.find('.js-tabs-page[data-type="'+$tabsContainer.data('type')+'"]');
            }else{
                var $pages = $tabsContainer.find('.js-tabs-page');
            }
            $tab.siblings().removeClass('active');
            $tab.addClass('active');
            if($tab.data('id') === 'all'){
                $pages.addClass('active');
            }else{
                $pages.removeClass('active');
                var $page = $pages.filter('[data-id="'+$tab.data('id')+'"]');
                $page.addClass('active');
            }
        }

        $(function() {
            refreshTabs();
        });
    };

    return {
        init:init
    };
};

export default Tabs;